// extracted by mini-css-extract-plugin
export default {"books":"textbooks_books__JXvdj"};